import { Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { dialogContent, dialogTitle, paperProps } from 'app/components/AsanConfirmation/AsanConfirmation.sx';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import AsanImza from 'app/components/AsanImzaComponent/AsanImza';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  verifyCode?: any;
  timerTime?: any;
  pathUrl?: any;
  businessKey?: any;
  isRegistration?: boolean;
  title?: string;
  redirectUrl?: string;
  isClosedAsanModal?: boolean;
}
const AsanConfirmation = (props: Props) => {
  const {
    open,
    close,
    verifyCode,
    timerTime,
    pathUrl,
    businessKey,
    isRegistration = false,
    title,
    redirectUrl,
    isClosedAsanModal,
  } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={(event, reason) => {
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
          return;
        }
        close(false);
      }}
    >
      <DialogTitle sx={dialogTitle}>
        <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>{t('commonTerms.confirmAsanImza')}</Typography>
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        <AsanImza
          isRegistration={isRegistration}
          btnSx={{ marginTop: '62px' }}
          asanModalType={'transfer'}
          verifyCode={verifyCode}
          close={close}
          timerTime={timerTime}
          pathUrl={pathUrl}
          businessKey={businessKey}
          title={title}
          redirectUrl={redirectUrl}
          isClosedAsanModal={isClosedAsanModal}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AsanConfirmation;
